(function () {
  var STORAGE_KEY = 'emma-collection-grid-layout';
  var VALID_LAYOUTS = ['1-tile', '2-tile'];
  var DEFAULT_LAYOUT = '2-tile';

  function normalizeLayout(value) {
    return VALID_LAYOUTS.indexOf(value) !== -1 ? value : DEFAULT_LAYOUT;
  }

  function applyLayout(grid, layout, buttons) {
    grid.classList.remove('collection-grid-layout--1-tile', 'collection-grid-layout--2-tile');
    grid.classList.add('collection-grid-layout--' + layout);

    if (!buttons) return;

    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-collection-grid-layout') === layout;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('[data-collection-product-grid]');
    var toggle = document.querySelector('[data-collection-grid-layout-toggle]');
    if (!grid || !toggle) return;

    var buttons = toggle.querySelectorAll('[data-collection-grid-layout]');
    var savedLayout = normalizeLayout(window.localStorage.getItem(STORAGE_KEY));
    applyLayout(grid, savedLayout, buttons);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var layout = normalizeLayout(btn.getAttribute('data-collection-grid-layout'));
        window.localStorage.setItem(STORAGE_KEY, layout);
        applyLayout(grid, layout, buttons);
      });
    });
  });
})();
